import React from 'react';
import cookieDough from 'cookie-dough';
import Grid from '../Grid';
import { Auth0BannerStyled, Title, ButtonWrapper, Button } from './styled';

const cookie = cookieDough();
const AB_TEST = 'cta-features-pgs';

const Auth0Banner = ({ abExperiments }) => {
  const ab = abExperiments || JSON.parse(cookie.get('ajs_ab.traits'));
  return (
    <Auth0BannerStyled>
      <Grid>
        <Title>
          Never compromise <br /> on <em>identity</em>.
        </Title>
        {ab && ab[AB_TEST] === 'variant' ?
          (
            <ButtonWrapper>
              <Button target="_blank" href="/get-started" className="btn btn-lg btn-success">
                Get Started
              </Button>
              <Button
                target="_blank"
                href="https://auth0.com/docs/applications/machine-to-machine"
                className="btn btn-lg btn-default">
                  Read the docs
                </Button>
            </ButtonWrapper>
          ) : (
            <ButtonWrapper>
              <Button href="javascript:signup()" className="btn btn-lg btn-success">
                USE AUTH0 FOR FREE
              </Button>
              <Button className="btn btn-lg btn-default open-contact-form-modal">TALK TO SALES</Button>
            </ButtonWrapper>
          )
        }
      </Grid>
    </Auth0BannerStyled>
  );
};

export default Auth0Banner;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Auth0Banner/Auth0Banner.js